import { getAccessToken } from '../services/client';
import * as discounts from '../services/discounts';
import useAsync, { Async } from './useAsync';

/**
 * The offers a signed-in customer can see, from the platform.
 *
 * Fetch-on-mount, like `useCatalogue` - a handful of rows that change about as
 * often as the offers themselves do, so one fetch per mount of `CouponSheet`
 * is plenty rather than a request per keystroke.
 *
 * `enabled: signedIn` rather than an unconditional fetch: the endpoint sits
 * behind the same bearer auth every `services/*.ts` call uses, and asking
 * before there is a token to send would just be a 401 the sheet has to
 * explain away. Signed out reads as "no offers" - the same empty state the
 * sheet already draws for a real empty list - rather than as an error.
 */
export function useDiscounts(): Async<discounts.Discount[]> {
  const signedIn = !!getAccessToken();
  return useAsync(() => discounts.fetchAvailableDiscounts(), [], {
    enabled: signedIn,
  });
}

export default useDiscounts;
